export default __webpack_public_path__ + "static/media/7.5068fd08.png";